export default __webpack_public_path__ + "static/hero-1-1e75224b59e74d85393ff0fe121cf54b.webp";